// extracted by mini-css-extract-plugin
export default {"container":"PictureStyles_container__h74K8"};